import feathers from '@feathersjs/client';
import { config } from '../utils/utils';
import axios from 'axios';
import rest from '@feathersjs/rest-client';
import { toastHandler } from '../utils/toastHandler';
import { getItem } from '../utils/localStorage';

export const feathersClient = feathers();

// For GET requests
axios.interceptors.request.use(
  (req: any) => {
    // Add configurations here
    // const authKey = localStorage.getItem(config.AUTH_KEY);
    // if (authKey) {
    //   req.headers.Authorization = `Bearer ${authKey}`;
    // }
    return req;
  },
  (err) => {
    toastHandler(err?.response?.data);
    return Promise.reject(err);
  }
);

const restClient = rest(config.BASE_URL);
feathersClient.configure(restClient.axios(axios));
feathersClient.configure(feathers.authentication());

feathersClient.configure(
  feathers.authentication({
    storageKey: config.AUTH_KEY,
    storage: window.localStorage,
  })
);

(feathersClient as any).authenticate({
  strategy: 'anonymous',
});

export let axiosInstance = axios.create({
  baseURL: config.BASE_URL,
});

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.request.use(
  function (configs) {
    let userToken = getItem(config.AUTH_KEY);
    let BEARER_TOKEN = userToken.length > 0 ? userToken : config.BEARER_TOKEN;

    configs.headers.Authorization = `Bearer ${BEARER_TOKEN}`;
    if (!configs.headers?.['Content-Type'])
      configs.headers['Content-Type'] = 'application/json';
    return configs;
  },
  function (error) {
    return Promise.reject(error);
  }
);